import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  /**
     * Transform
     *
     * @param {any[]} items
     * @param {string} searchText
     * @returns {any[]}
     */
  transform(items: any[], searchTxt: string): any[] {
    let searchText = searchTxt
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter(it => {
      if (it.businessId) {
        return it.name.toLocaleLowerCase().includes(searchText);
      } else {
        return it.business_name.toLocaleLowerCase().includes(searchText);
      }
    });
  }
}
